<section class="rcx-table" [formGroup]="exitInterviewForm">
  <div class="row">
    <div class="col-lg-12">
      <div class="card btr">
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="row g-3">
                <div class="col-md-4">
                  <label for="feedback" class="form-label">Feedback<b class="text-secondary">*</b></label>
                  <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                        class='bx bx-building'></i></span>
                    <input type="text" class="form-control ps-1" id="feedback" placeholder="Enter the feedback"
                      [ngClass]="{'is-invalid': submitted && s.feedback?.errors}" formControlName="feedback"
                      autocomplete="off" [readonly]="context.persona === 'HR' || exitInterviewForm.value.id" />
                  </div>
                  <div
                    *ngIf="exitInterviewForm.get('feedback')?.invalid && (exitInterviewForm.get('feedback')?.dirty || exitInterviewForm.get('feedback')?.touched)">
                    <small class="text-danger" *ngIf="exitInterviewForm.get('feedback').errors?.required">Please enter
                      your feedback.</small>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="rating" class="form-label">Rating<b class="text-secondary">*</b></label>
                  <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                        class='bx bx-building'></i></span>
                    <input type="text" class="form-control ps-1" id="rating" placeholder="Enter the rating"
                      [ngClass]="{'is-invalid': submitted && s.rating?.errors}" formControlName="rating"
                      autocomplete="off" [readonly]="context.persona === 'HR' || exitInterviewForm.value.id" />
                  </div>
                  <div
                    *ngIf="exitInterviewForm.get('feedback')?.invalid && (exitInterviewForm.get('feedback')?.dirty || exitInterviewForm.get('feedback')?.touched)">
                    <small class="text-danger" *ngIf="exitInterviewForm.get('rating').errors?.required">Please enter the
                      rating.
                    </small>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="email" class="form-label">Email<b class="text-secondary">*</b></label>
                  <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                        class='bx bx-building'></i></span>
                    <input type="text" class="form-control ps-1" id="email" placeholder="Enter the email"
                      [ngClass]="{'is-invalid': submitted && s.email?.errors}" formControlName="email"
                      autocomplete="off" [readonly]="context.persona === 'HR'|| exitInterviewForm.value.id" />
                  </div>
                  <div
                    *ngIf="exitInterviewForm.get('email')?.invalid && (exitInterviewForm.get('email')?.dirty || exitInterviewForm.get('email')?.touched)">
                    <small class="text-danger" *ngIf="exitInterviewForm.get('email').errors?.required">Please enter the
                      email.</small>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="contact" class="form-label">Contact<b class="text-secondary">*</b></label>
                  <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                        class='bx bx-building'></i></span>
                    <input type="text" class="form-control ps-1" id="contact" placeholder="Enter the contact"
                      [ngClass]="{'is-invalid': submitted && s.contact?.errors}" formControlName="contact"
                      autocomplete="off" [readonly]="context.persona === 'HR' || exitInterviewForm.value.id" />
                  </div>
                  <div
                    *ngIf="exitInterviewForm.get('contact')?.invalid && (exitInterviewForm.get('contact')?.dirty || exitInterviewForm.get('contact')?.touched)">
                    <small class="text-danger" *ngIf="exitInterviewForm.get('contact').errors?.required">Please enter
                      the contact.</small>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="suggestions" class="form-label">Suggestions<b class="text-secondary">*</b></label>
                  <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                        class='bx bx-building'></i></span>
                    <input type="text" class="form-control ps-1" id="suggestions" placeholder="Enter the suggestions"
                      [ngClass]="{'is-invalid': submitted && s.suggestions?.errors}" formControlName="suggestions"
                      autocomplete="off" [readonly]="context.persona === 'HR' || exitInterviewForm.value.id" />
                  </div>
                  <div
                    *ngIf="exitInterviewForm.get('suggestions')?.invalid && (exitInterviewForm.get('suggestions')?.dirty || exitInterviewForm.get('suggestions')?.touched)">
                    <small class="text-danger" *ngIf="exitInterviewForm.get('suggestions').errors?.required">Please enter
                      the suggestions.</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>